import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Skeleton } from "@/components/ui/skeleton";

interface ContentListSkeletonProps {
  skeletonCount?: number;
}

export const ContentListSkeleton: React.FC<ContentListSkeletonProps> = ({
  skeletonCount = 6,
}) => {
  return (
    <div className="w-full">
      <Table>
        <TableHeader>
          <TableRow className="border-b border-border/60 hover:bg-transparent">
            <TableHead className="w-auto text-muted-foreground">
              Title
            </TableHead>
            <TableHead className="w-[140px] text-muted-foreground">
              Added On
            </TableHead>
            <TableHead className="w-[120px] text-muted-foreground">
              Visibility
            </TableHead>
            <TableHead className="w-[100px] text-right text-muted-foreground">
              <Skeleton className="ml-auto h-4 w-14" />
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {[...Array(skeletonCount)].map((_, index) => (
            <TableRow
              key={index}
              className="border-b border-border/60"
            >
              <TableCell className="font-medium">
                <div className="flex items-center gap-2">
                  <Skeleton className="h-4 w-4 shrink-0" />
                  <Skeleton className="h-4 w-[200px]" />
                </div>
              </TableCell>
              <TableCell className="text-sm">
                <Skeleton className="h-4 w-20" />
              </TableCell>
              <TableCell className="text-sm">
                <Skeleton className="h-4 w-16" />
              </TableCell>
              <TableCell className="text-right">
                <Skeleton className="ml-auto h-8 w-8 rounded-full" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
